module.exports = __webpack_public_path__ + "static/media/ALICE-BNB.a697f16f.svg";